import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from '@sentry/react';
import { MARKET } from './firebase';

// 2026-08 Codexレビュー指摘対応（MUST-FIX）：グローバルErrorBoundaryのfallback画面は
// Appコンポーネント外（tenantProfile.marketId由来のisAUが使えない場所）にあるため、
// ビルド時に確定するREACT_APP_MARKET環境変数（MARKET定数）で判定する
const IS_AU_BUILD = MARKET === "au";

// DSN が設定されている場合のみ Sentry を有効化
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV, // "development" / "production"
    // 本番のみ有効にしたい場合は下記をコメント解除
    // enabled: process.env.NODE_ENV === 'production',
    tracesSampleRate: 0.2, // パフォーマンストレース 20% サンプリング
  });
}

// 2026-08 AU版基盤（Phase 1）：GA4タグをpublic/index.htmlの静的スクリプトから
// ここへ移動した。REACT_APP_GA4_MEASUREMENT_IDS（カンマ区切り、例："G-XXXXXXX,G-YYYYYYY"）が
// 設定されていればそれを使い、未設定時は日本版の既存2測定ID
// （G-BGTX5QN35N, G-7MWVQ755EE）にフォールバックする。これにより、
// REACT_APP_GA4_MEASUREMENT_IDSを設定しない既存のビルド手順は、旧
// public/index.htmlに静的記述されていたものと完全に同じgtag呼び出し
// （同じ測定ID・同じ順序）になる。
// AU版ビルドは別のREACT_APP_GA4_MEASUREMENT_IDS（AU専用プロパティ）を
// 指定することで、日本版の測定IDへは一切送信しない
// （二重計測防止・JP/AUクロス防止）
const DEFAULT_GA4_MEASUREMENT_IDS = ["G-BGTX5QN35N", "G-7MWVQ755EE"];
const ga4MeasurementIds = process.env.REACT_APP_GA4_MEASUREMENT_IDS
  ? process.env.REACT_APP_GA4_MEASUREMENT_IDS.split(",").map((s) => s.trim()).filter(Boolean)
  : DEFAULT_GA4_MEASUREMENT_IDS;

if (ga4MeasurementIds.length > 0) {
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(ga4MeasurementIds[0])}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  ga4MeasurementIds.forEach((id) => window.gtag("config", id));
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <div style={{ padding: 32, textAlign: 'center', fontFamily: 'sans-serif' }}>
          <div style={{ fontSize: 24, marginBottom: 12 }}>{IS_AU_BUILD ? '⚠️ Something went wrong' : '⚠️ エラーが発生しました'}</div>
          <div style={{ color: '#666', marginBottom: 20 }}>
            {IS_AU_BUILD ? 'The issue has been logged. Please reload the page.' : '問題を記録しました。ページを再読み込みしてください。'}
          </div>
          <button
            onClick={() => window.location.reload()}
            style={{ padding: '10px 24px', borderRadius: 8, background: '#111', color: 'white', border: 'none', cursor: 'pointer', fontSize: 14 }}
          >
            {IS_AU_BUILD ? 'Reload' : '再読み込み'}
          </button>
        </div>
      }
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
